import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#17203D",
    },
    secondary: {
      main: "#0056B3",
    },
    background: {
      default: "#F4F6F8",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#17203D",
      secondary: "#5A5A5A",
    },
    success: {
      main: '#00A76F',
    }
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
      color: "#17203D",
      "@media (max-width:600px)": {
        fontSize: "1.5rem",
      },
    },
    h2: {
      fontSize: "1.8rem",
      fontWeight: 500,
      color: "#17203D",
      "@media (max-width:600px)": {
        fontSize: "1.4rem",
      },
    },
    h4: {
      fontSize: "1.2rem",
      fontWeight: 500,
      color: "#17203D",
      "@media (max-width:600px)": {
        fontSize: "0.875rem",
      },
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
      color: "#17203D",
      "@media (max-width:600px)": {
        fontSize: "0.775rem",
      },
    },
    body1: {
      fontSize: "1rem",
      color: "#5A5A5A",
      "@media (max-width:600px)": {
        fontSize: "0.875rem",
      },
    },
    body3: {
      fontSize: "0.875rem",
      color: "#5A5A5A",
      "@media (max-width:600px)": {
        fontSize: "0.55rem",
      },
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "10px 16px",
          "@media (max-width:600px)": {
            padding: "8px 12px",
            fontSize: "0.875rem",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
          "@media (max-width:600px)": {
            borderRadius: "8px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          "@media (max-width:600px)": {
            "& .MuiInputBase-input": {
              fontSize: "0.875rem",
            },
          },
        },
      },
    },
    // Add mobile-specific styles for other components as needed
  },
});

export function AppThemeProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default AppThemeProvider;